export default __webpack_public_path__ + "static/studyoffice-study1-78f85d5969e1cd842c49d5d534e41e3f.jpg";